const casino1 = "../assets/images/tab-image/casino1.webp";
const casino2 = "../assets/images/tab-image/casino2.webp";
const casino3 = "../assets/images/tab-image/casino3.webp";
const casino4 = "../assets/images/tab-image/casino4.webp";
const casino5 = "../assets/images/tab-image/casino5.webp";
const casino6 = "../assets/images/tab-image/casino6.webp";
const casino7 = "../assets/images/tab-image/casino7.webp";
const casino8 = "../assets/images/tab-image/casino8.webp";
const casino9 = "../assets/images/tab-image/casino9.webp";
const casino10 = "../assets/images/tab-image/casino10.webp";
const casino11 = "../assets/images/tab-image/casino11.webp";


const newslotJili = "../assets/images/tab-image/jili.webp";
const newslotJdb = "../assets/images/tab-image/jdb.webp";
const newslotPt = "../assets/images/tab-image/playtech.webp";
const newslotPp = "../assets/images/tab-image/pp.webp";
const newslotRt = "../assets/images/tab-image/rt.webp";
const newslotSg = "../assets/images/tab-image/sg.webp";
const newSlotPg = "../assets/images/tab-image/pg.webp";
const newSlotYl = "../assets/images/tab-image/yl.webp";
const newSlotYesbingo = "../assets/images/tab-image/yb.webp"
const newSlotFc = "../assets/images/tab-image/fc.webp";


// Table Image
const tableJili = "../assets/images/tab-image/table_jili.webp";
const tableSpg = "../assets/images/tab-image/table_spg.webp";
const tableKm = "../assets/images/tab-image/table_km.webp";
const tableLudo = "../assets/images/tab-image/table_ludo.webp";
const tablePg = "../assets/images/tab-image/table_pg.webp";
// Sports Image
const sabaSports = "../assets/images/tab-image/saba_sports.webp";
const virtualcricket = "../assets/images/tab-image/virtual-cricket.jpeg";

// Fishing Image
const fishingJili = "../assets/images/tab-image/fishing_jili.webp";
const fishingSpg = "../assets/images/tab-image/fishing_spg.webp";

const fishingFc = "../assets/images/tab-image/fishing_fc.webp";
const fishingJdb = "../assets/images/tab-image/fishing_jbd.webp";
const fishingYb = "../assets/images/tab-image/fishing_yb.webp";
const fishingYl = "../assets/images/tab-image/fishing_yl.webp";
const cockFight = "../assets/images/tab-image/cfight.webp";



export const DepositWithrawDataArray = [
  
  {
    id: 1,
    title: "Home",
    key: "homegame",
    titlebn: "গরম খেল",
    
  },
  {
    id: 3,
    title: "Casino",
    key: "casino",
    titlebn: "লাইভ ক্যাসিনো",
    array: [
      
      {
        image: casino2,
        title: "Evo",
        type: "evo",
        key: "casino",
        gameTypeCheck: "platForm",
        platForm: "EVOLUTION",
        gameType: "LIVE",
        casinoType: "",
      },
      {
        image: casino3,
        title: "SEXY",
        type: "sexy",
        key: "casino",
        gameTypeCheck: "platForm",
        platForm: "SEXYBCRT",
        gameType: "LIVE",
        casinoType: "MX-LIVE-002",
      },
      {
        image: casino4,
        title: "PT",
        type: "pt",
        key: "casino",
        gameTypeCheck: "platForm",
        platForm: "PT",
        gameType: "LIVE",
      },
      {
        image: casino5,
        title: "PP",
        type: "pp",
        key: "casino",
        gameTypeCheck: "platForm",
        platForm: "PP",
        gameType: "LIVE",
        casinoType: "",
      },
 
      {
        image: casino8,
        title: "Big Gaming",
        type: "biggaming",
        key: "casino",
        gameTypeCheck: "platForm",
        platForm: "BG",
        gameType: "",
        casinoType: "",
      },
      {
        image: casino9,
        title: "Horsebook",
        type: "horsebook",
        key: "casino",
        gameTypeCheck: "platForm",
        platForm: "HORSEBOOK",
        gameType: "LIVE",
        casinoType: "HRB-LIVE-001",
      },
      {
        image: casino10,
        title: "SV388",
        type: "SV388",
        key: "casino",
        gameTypeCheck: "platForm",        
        platForm: "SV388",
        gameType: "LIVE",
        casinoType: "SV-LIVE-001",
      },
      {
        image: casino11,
        title: "Venus",
        type: "venus",
        key: "casino",
        gameTypeCheck: "platForm",
        platForm: "VENUS",
        gameType: "",
        casinoType: "",
      },
    ],
  },
 
  {
    id: 4,
    title: "Slot",
    key: "slot",
    titlebn: "স্লট",
    array: [  
      {
        image: newslotJili,
        title: "Jili",
        type: "jili",
        key: "slot",
        gameTypeCheck: "platForm",
        isPlateform: true,
        gameType: "SLOT",
        platForm: "JILI",
      },
      {
        image: newslotJdb,
        title: "JDB",
        type: "jdb",
        key: "slot",
        gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "JDB",
      },
      {
        image: newslotPt,
        title: "PT",
        type: "pt",
        key: "slot",
        gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "PT",
      },
      {
        image: newslotPp,
        title: "PP",
        type: "pp",
        key: "slot",
        gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "PP",
      },
      {
        image: newslotRt,
        title: "RT",
        type: "rt",
        key: "slot",
        gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "FC",
      },
      
      {
        image: newslotSg,
        title: "SG",
        type: "spade",
        key: "slot",
        gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "SPADE",
      },
      {
        image: newSlotPg,
        title: "PG",
        type: "pg",
        key: "slot",
        gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "PG",
      },
      {
        image: newSlotFc,
        title: "FC",
        type: "fc",
        key: "slot",
        gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "FC",
      },
      {
        image: newSlotYesbingo,
        title: "Yes Bingo",
        type: "yesbingo",
        key: "slot",
        gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "YESBINGO",
      },
      {
        image: newSlotYl,
        title: "YL",
        type: "yl",
        key: "slot",
        gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "YL",
      },
    ],
  },
  {
    id: 5,
    title: "Table",
    key: "table",
    titlebn: "টেবিল",
    array: [
      
      {
        image: tableJili,
        title: "Jili",
        type: "jili",
        key: "table",
        gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "JILI",
      },
      {
        image: tableKm,
        title: "KM",
        type: "kingmaker",
        key: "table",
        gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "KINGMAKER",
      },   
      {
        image: tableSpg,
        title: "SG",
        type: "spade",
        key: "table",
        gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "SPADE",
      },
      {
        image: tableLudo,
        title: "Ludo",
        type: "ludo",
        key: "table",
        gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "LUDO",
        casinoType:"LUDO-TABLE-001"
      },
      {
        image: tablePg,
        title: "PG",
        type: "pg",
        key: "table",
        gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "PG",
        casinoType:"PG-TABLE-001"
      },
    ],
  },
  {
    id: 6,
    title: "Sports",
    key: "sports",
    titlebn: "বিনিময়",
    array: [
    
      {
        image: sabaSports,
        title: "Saba Sports",
        link: "",
        key:"sports",
        gameTypeCheck: "platForm",
        platForm: "SABA",
        gameType: "VIRTUAL",
        casinoType: "SABA-VIRTUAL-001",
      },
      // {
      //   image: cmd,
      //   title: "CMD Sportbook",
      //   link: "",
      //   key:"sports",
      //   gameTypeCheck: "egtGame",
      //   platForm: "SABA",
      //   gameType: "VIRTUAL",
      //   casinoType: "SABA-VIRTUAL-001",
      // },
      
      {
        image: virtualcricket,
        title: "Virtual cricket",
        link: "",
        key:"sports",
        gameTypeCheck: "platForm",
        platForm: "SABA",
        gameType: "VIRTUAL",
        casinoType: "SABA-VIRTUAL-001",
      },
      
    ],
  },
  
  {
    id: 7,
    title: "Fishing",
    key: "fish",
    type: "fish",
    array: [
  
      {
        image: fishingJili,
        title: "Jili",
        type: "jili",
        key: "fish",
        gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "JILI",
      },
      {
        image: fishingSpg,
        title: "Spade",
        type: "spade",
        key: "fish",
        gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "SPADE",
      },
      {
        image: fishingFc,
        title: "FC Fishing",
        type: "fc",
        key: "fish",
        gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "FC",
      },
      {
        image: fishingJdb,
        title: "JDB Fishing",
        type: "jdb",
        key: "fish",
        gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "JDB",
      },
      {
        image: fishingYb,
        title: "Yes Bingo",
        type: "yesbingo",
        key: "fish",
        gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "YESBINGO",
        casinoType:"YesBingo-FH-001"
      },
      {
        image: fishingYl,
        title: "Yl Fishing",
        type: "yl",
        key: "fish",
        gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "YL",
      
      },
    ],
  },
  
  {
    id: 7,
    title: "Cock Fight",
    key: "arcade",
    type: "arcade",
    array: [
  
      {
        image: cockFight,
        title: "Cock Fight",
        type: "cockfight",
        key: "arcade",
        gameTypeCheck: "platForm",
        platForm: "SV388",
        gameType: "LIVE",
        casinoType: "SV-LIVE-001",
      },
      
    ],
    
  },
  {
    id: 8,
    title: "Crash",
    key: "crash",
    titlebn: "স্পোর্টসবুক",
    array: [
      
      // {
      //   id: 1,
      //   image: crashhotgame030,
      //   title: "Go Rush",
      //   type: "Go Rush",
      //   gameTypeCheck: "platForm",
      //   platForm: "JILI",
      //   gameType: "TABLE",
      //   casinoType: "JILI-TABLE-030",
      // },
      // -------------------CRASH SPRIBE START-----------------];
{
  image: "../assets/images/crash/spribe/SPRIBE-EGAME-001.png",
  title: "Aviator",
  category:"crash",
  type:"SPRIBE",
  platForm: "SPRIBE",
  gameType: "EGAME",
  casinoType: "SPRIBE-EGAME-001",
},

// -------------------CRASH SPRIBE END-----------------];


// -------------------CRASH JILI START-----------------];
{
  image: "../assets/images/crash/jili/JILI-TABLE-047.png",
  title: "Crash Bonus",
  category:"crash",
  type:"JILI",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-047",
},
{
  image: "../assets/images/crash/jili/JILI-TABLE-058.png",
  title: "Crash Cricket",
  category:"crash",
  type:"JILI",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-058",
},
{
  image: "../assets/images/crash/jili/JILI-TABLE-030.png",
  title: "Go Rush",
  category:"crash",
  type:"JILI",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-030",
},
{
  image: "../assets/images/crash/jili/JILI-TABLE-035.png",
  title: "Limbo",
  category:"crash",
  type:"JILI",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-035",
},
{
  image: "../assets/images/crash/jili/JILI-TABLE-055.png",
  title: "Crash Goal",
  category:"crash",
  type:"JILI",
  platForm: "JILI",
  gameType: "TABLE",
  casinoType: "JILI-TABLE-055",
},
// -------------------CRASH JILI END-----------------];

// -------------------CRASH PP START-----------------];

{
  image: "../assets/images/crash/pp/PP-EGAME-008.png",
  title: "High Flyer ",
  category:"crash",
  type:"PP",
  platForm: "PP",
  gameType: "EGAME",
  casinoType: "PP-EGAME-008",
},
{
  image: "../assets/images/crash/pp/PP-EGAME-001.png",
  title: "Spaceman",
  category:"crash",
  type:"PP",
  platForm: "PP",
  gameType: "EGAME",
  casinoType: "PP-EGAME-001",
},
{
  image: "../assets/images/crash/pp/PP-EGAME-009.png",
  title: "Big Bass Crash",
  category:"crash",
  type:"PP",
  platForm: "PP",
  gameType: "EGAME",
  casinoType: "PP-EGAME-009",
},
// -------------------CRASH PP END-----------------];

// -------------------CRASH KINGMAKER START-----------------];

{
  image: "../assets/images/crash/kingmaker/KM-TABLE-041.png",
  title: "Cash Rocket",
  category:"crash",
  type:"KINGMAKER",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-041",
},
{
  image: "../assets/images/crash/kingmaker/KM-TABLE-069.png",
  title: "Elite Aviator Club",
  category:"crash",
  type:"KINGMAKER",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-069",
},
{
  image: "../assets/images/crash/kingmaker/KM-TABLE-070.png",
  title: "Interstellar Run",
  category:"crash",
  type:"KINGMAKER",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-070",
},
{
  image: "../assets/images/crash/kingmaker/KM-TABLE-075.png",
  title: "Iron Dome",
  category:"crash",
  type:"KINGMAKER",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-075",
},
{
  image: "../assets/images/crash/kingmaker/KM-TABLE-076.png",
  title: "TOON CRASH",
  category:"crash",
  type:"KINGMAKER",
  platForm: "KINGMAKER",
  gameType: "TABLE",
  casinoType: "KM-TABLE-076",
},
// -------------------CRASH KINGMAKER END-----------------];

    ],
      
 
  },
 
];